import { Navigate, Outlet } from 'react-router-dom'
import createStripeSubscriptionAction from '../../actions/createStripeSubscriptionAction'
import completePaymentLoader from '../../loaders/completePaymentLoader'
import getPricesLoader from '../../loaders/getPricesLoader'
import getUserLoader from '../../loaders/getUserLoader'
import PaymentCompletionPage from './PaymentCompletionPage'
import PaymentPage from './PaymentPage'
import PlansPage from './PlansPage'

/**
 * Individual route exports for apps that compose their own checkout routes
 * (e.g., when A/B testing the plans page but keeping payment routes shared)
 */
export const paymentRoute = {
  element: <PaymentPage />,
  loader: async ({ request }: { request: Request }) =>
    Promise.all([getPricesLoader(), getUserLoader({ request })]),
  path: 'payment',
}

export const paymentCompletionRoute = {
  element: <PaymentCompletionPage />,
  loader: completePaymentLoader,
  path: 'payment-completion',
}

export const plansRoute = {
  action: createStripeSubscriptionAction,
  element: <PlansPage />,
  loader: getPricesLoader,
  path: 'plans',
}

export { default as createStripeSubscriptionAction } from '../../actions/createStripeSubscriptionAction'
export { default as getPricesLoader } from '../../loaders/getPricesLoader'
export { default as getUserLoader } from '../../loaders/getUserLoader'
export { default as PlansPage } from './PlansPage'

/**
 * Full checkout routes bundle for apps that don't A/B test checkout.
 * Includes plans, payment, and payment-completion routes.
 */
const checkoutRoutes = [
  {
    element: <Outlet />,
    loader: getUserLoader,
    path: '/checkout',
    children: [
      {
        index: true,
        element: <Navigate to="plans" replace />,
      },
      paymentRoute,
      paymentCompletionRoute,
      plansRoute,
    ],
  },
]

export default checkoutRoutes
